import './hero.css';
import Button from '../shared/button';
import { ArrowCircleRight } from '../shared/icons';

export default ({data}) => {
  if(!data) {
    return <></>
  }
  const hero = data;
  return <div className="row hero-row">
    <article className="flex-col hero-container">
      <h1>{hero.heading}</h1>
      <h4>{hero.subHeading}</h4>
      <div className="button-group">
        {
          hero.buttons.map(cta =>
            <a href={cta.linkUrl} target="_blank" key={cta.linkUrl}>
            <Button icon={ArrowCircleRight}>
              {cta.label}
            </Button>
            </a>
          )
        }
      </div>
    </article>
    <img src={hero.imageUrl} className="hero-bg-image" />
  </div>
}